import { ArrowBack } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import text from 'components/shared/css/text.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import LogoIcon from 'static/svgs/logo';
import { authActions } from '../../../redux/slice/auth.slice';
import styles from '../Login/login.module.scss';
import LoginSlider from '../Login/LoginSlider';
import EmailForm from './EmailForm';
import TwoFaForm from './TwoFaForm';
import LogoIcon2 from 'static/svgs/logo2';
const ForgotPasswordContainer = () => {
  const loginTab = useSelector(authActions.selectors.getLoginTab);
  const dispatch = useDispatch();

  const handleBackClick = () => {
    dispatch(authActions.actions.setLoginTab(loginTab - 1))
  }

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <LogoIcon2 />
        {loginTab > 0 &&
          <div className={styles.backButtonContainer}>
            <IconButton onClick={handleBackClick}>
              <ArrowBack />
            </IconButton>
          </div>
        }
        <div className={styles.loginBox}>
          {loginTab === 0 &&
            <EmailForm />
          }

          {loginTab === 1 &&
            <TwoFaForm />
          }

        </div>
      </div>
      <div className={styles.right}>
        <div>
          <LoginSlider />
        </div>
        <p className={`${text.normal2} ${text.textWhite} ${text.textCenter}`}>© 2022 QuantLayer. All rights reserved</p>
      </div>
    </div>
  )
}

export default ForgotPasswordContainer
